export function getNewsSortName (newsSorts, sortId) {
  let sortName = ''
  for (let i = 0; i < newsSorts.length; i++) {
    let sort = newsSorts[i]
    if (sort.id === sortId) {
      sortName = sort.name
      break
    }
  }
  return sortName
}



// WEBPACK FOOTER //
// ./src/utils/myNewsSortUtil.js